import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Eye, Cookie, Scale, Mail, Network, FileSignature, Building2 } from "lucide-react";
import { PageHeader } from "./Services";
import { ALL_POLICIES, COMPANY } from "../lib/policyContent";

const ICONS = {
  "privacy-policy": Eye,
  "cookie-policy": Cookie,
  "terms": Scale,
  "sms-email-marketing-policy": Mail,
  "acceptable-traffic-sources-policy": Network,
  "data-usage-agreement": FileSignature,
};

export default function LegalCentre() {
  React.useEffect(() => {
    document.title = "Legal Centre | PlayerReach";
  }, []);
  return (
    <div data-testid="legal-centre-page">
      <PageHeader
        eyebrow="Legal Centre"
        title="Policies, terms and governance documents."
        subtitle={`This Legal Centre provides access to the policies, terms and governance documents that apply to ${COMPANY.domain} and relevant services operated by ${COMPANY.entity}.`}
      />

      <section className="section-pad">
        <div className="container-pr">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {ALL_POLICIES.map((p, i) => {
              const Icon = ICONS[p.slug] || FileSignature;
              return (
                <Link key={p.slug} to={`/legal/${p.slug}`} className="group relative card-flat p-7 transition-transform hover:-translate-y-0.5" data-testid={`legal-card-${p.slug}`}>
                  <div className="absolute left-0 top-0 bottom-0 w-1 rounded-l-xl bg-[#0052FF]" />
                  <div className="flex items-center justify-between">
                    <span className="inline-flex h-10 w-10 items-center justify-center rounded-md bg-slate-50 border border-slate-200 text-[#0052FF]">
                      <Icon className="h-5 w-5" />
                    </span>
                    <span className="text-xs text-slate-400 font-mono-pr">0{i + 1}</span>
                  </div>
                  <h3 className="font-display mt-5 text-lg font-semibold text-slate-900">{p.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{p.shortDesc}</p>
                  <div className="mt-5 flex items-center justify-between text-sm">
                    <span className="text-slate-500">v{COMPANY.version} · {COMPANY.effectiveDate}</span>
                    <span className="inline-flex items-center gap-1 font-medium text-[#0052FF] group-hover:underline">Read <ArrowUpRight className="h-3.5 w-3.5" /></span>
                  </div>
                </Link>
              );
            })}
          </div>

          <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-6 items-center rounded-xl border border-slate-200 bg-slate-50 p-8">
            <div className="lg:col-span-8 flex items-start gap-4">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-md bg-white border border-slate-200 text-slate-700 flex-shrink-0">
                <Building2 className="h-5 w-5" />
              </span>
              <div>
                <p className="overline">Operating entity</p>
                <p className="mt-1 text-slate-700 leading-relaxed">
                  {COMPANY.entity} · Formation Number {COMPANY.formation} · {COMPANY.address}
                </p>
              </div>
            </div>
            <div className="lg:col-span-4 lg:text-right">
              <Link to="/contact" className="btn-primary text-sm" data-testid="legal-cta-contact">
                Compliance contact <ArrowUpRight className="h-4 w-4" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
